var touch = Modernizr.touch;
var mobile = false;
var $window = $(window);
var swiper, prevScroll, headerFixed, navtopPosition, navtopPositionOff;

// Used to compensante Chrome/Safari bug (they don't care about scroll bar for width)
function scrollCompensate() 
{
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
}

function resize(){

    if (!mobile){
        // Controlar si ha saltado version mobile
        if ($(window).width()+scrollCompensate() < 740) { 
            mobile = true;
        } else {

        }
    // Controlar si no mobile version
    } else {
        if ($(window).width()+scrollCompensate() >= 740) {
            $('body').removeClass('ohidden');
                        
            mobile = false;  
        } else {
            $('#aside-header .scroll').height($(window).height()-64);
        }
    }
}

// header control to fixed position
function headerFix() {

    if ($(window).scrollTop() > navtopPositionOff) {
        $('#head-page').addClass('fixed');
    } else {
        $('#head-page').removeClass('fixed');
    }
}

// Animation elements

$(window).on('scroll resize', function () {
    headerFix();
});
$(window).trigger('scroll');

$(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
});

$(function(){
    $.material.init();

    var selplaceholder = "Select one";
    switch ($('html').attr('lang')) {
      case 'es':
        selplaceholder = "Selecciona uno";
        break;
      case 'ca':
        selplaceholder = "Selecciona un";
        break;
    }
    
    $('select').select2({
      placeholder: selplaceholder,
      allowClear: true
    });

    $('.counter_n').counter();

    if ($('#swiper-nav').length != 0) {
      var widthSwipeMenu = 0;
      $('#swiper-nav').each(function() {
          widthSwipeMenu += $(this).width()+10;
      });

      if (widthSwipeMenu > $('#swiper-nav').width()){
        if (!$('#swiper-nav').hasClass('swiper-container-initialized')){
          swiperNav= new Swiper('#swiper-nav', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
                nextEl: '.next',
                prevEl: '.prev',
            },
            speed: 600,
            effect: 'slide',
            simulateTouch:true,
            loop: false,
            on: {
              init: function () {
                  setTimeout(function(){
                      var currentPage = $( "#swiper-nav .swiper-slide.active" );
                      swiperNav.slideTo($( "#swiper-nav .swiper-slide" ).index( currentPage ),0 );
                  },0);
              },
            }                
          });
        }
      } else {
        if ($('#swiper-nav').hasClass('swiper-container-initialized')){
          swiperNav.destroy(true, true);
          setTimeout(function() {$('.swiper-wrapper').attr('style','');}, 100);
        }
      }
    }


    $(document).on("click", "#btn-menu", function() {
      if ($('#aside-header').hasClass('opened')){
			  $('#aside-header').removeClass('opened');
        $(this).removeClass('active');
        $('body').removeClass('ohidden');
        
      }else{
        $('#aside-header').addClass('opened');
        $(this).addClass('active');
        $('body').addClass('ohidden');
      };
    });


    if ($('.main-slide').length){
      var $ms=0;
      $(".main-slide").each(function() {
        var msImg = {};
        //var msCapt = {};
        var $nSlides = $(this).children('.main-slide .swiper-slide').length;
        $(this).addClass('ms'+ $ms).data('count',$ms);

        msImg[$ms] = new Swiper('.ms'+$ms, {
          slidesPerView: 1,
          spaceBetween:0,
          loop:true,
          autoplay: {
           delay: 5000,
          },
          loopedSlides: $nSlides,
          keyboard: {
            enabled: true
          },                    
          preloadImages: false,
          pagination: {
            el: '.msi-pagination',
            clickable: true,
          },          
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
            elementClass:'swiper-lazy'
          },
          a11y:{
            enabled:true,
            prevSlideMessage: 'Mostrar slide anterior',
            nextSlideMessage:'Mostrar slide siguiente',
            firstSlideMessage: 'Es el primer slide ganador',
            lastSlideMessage: 'Es último slide',
            paginationBulletMessage: 'Mostrar slide {{index}}',                        
          },
          init:false
        });
        msImg[$ms].on('init', function() {
          $('.msi'+ $ms).addClass('ready');
        }).init();
        $ms = $ms+1;
      });
    }


    if ($('.bss-swiper').length){
      var $bss=0;
      $(".bss-swiper").each(function() {
        var bssImg = {};
        //var msCapt = {};
        var $nSlides = $(this).children('.swiper-slide').length;
        $(this).addClass('bss'+ $bss).data('count',$bss);

        bssImg[$bss] = new Swiper('.bss'+$bss, {
          slidesPerView: 1,
          spaceBetween:0,
          loop:true,
          loopedSlides: $nSlides,
          keyboard: {
            enabled: true
          },                    
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
            elementClass:'swiper-lazy'
          },
          navigation: {
            nextEl: '.bss-next'
          },
          a11y:{
            enabled:true,
            prevSlideMessage: 'Mostrar slide anterior',
            nextSlideMessage:'Mostrar slide siguiente',
            firstSlideMessage: 'Es el primer slide ganador',
            lastSlideMessage: 'Es último slide',
            paginationBulletMessage: 'Mostrar slide {{index}}',                        
          }
        });
        $bss = $bss+1;
      });
    }
    //Accordions controls
    if ($('.accordion').length){
      $('.accordion .collapse').on('shown.bs.collapse', function () {
        var $scrollEl = $(this).closest('.card');
        var $scrollWTo = $scrollEl.offset().top;
        $('body, html').animate({ scrollTop: $scrollWTo - 80 }, 500);
      });
    }
    if ($('.singleteacher .table-subjects').length){
      $('.table-subjects .collapse').on('shown.bs.collapse', function () {
        var $scrollEl = $(this).closest('.card');
        var $scrollWTo = $scrollEl.offset().top;
        $('body, html').animate({ scrollTop: $scrollWTo - 80 }, 500);
      });
    }

});

$(window).on("load",function(){
  resize();
})

$(window).resize(function(){
  resize();
});

function sendSalesforce(cont_id){
  $('.form_'+cont_id+' .btn-enviar').hide();
  $('.form_'+cont_id+' .btn-enviando').show();
  //console.log($('.form_'+cont_id+' .btn-enviando').length);
  $('.form_'+cont_id+' .btn-enviarForm').prop("disabled",true);
  var csrfToken = $('meta[name="csrf-token"]').attr("content");
    var json = $('.form_'+cont_id).serializeObject();
    var form = document.querySelector('.form_'+cont_id);
    var formData = new FormData(form);
    
  formData.append("_csrf", csrfToken);
  formData.append("lang_id", $('.form_'+cont_id).attr("data-langid"));
  formData.append("cont_id", cont_id);
  formData.append("json", JSON.stringify(json));
  formData.append("page", window.location.href);
  $('.form_'+cont_id+' .msgOK,.form_'+cont_id+' .msgKO').hide();
  var baseurl = $('.form_'+cont_id).attr("data-baseurl");
  setTimeout(function(){
    $.ajax({
          url: baseurl+"/ajax/sendformsalesforce",
          type: 'POST',
          data: formData,
          dataType: 'json',
          async: false,
          success: function (data) {
            if(data.code==1){
              $('.form_'+cont_id+' .msgOK').show();
              $('.form_'+cont_id).addClass('sended');
              $('.form_'+cont_id+' input[type="text"]').val("");
              $('.form_'+cont_id+' input[type="email"]').val("");
              $('.form_'+cont_id+' textarea').val("");
            }else{
              $('.form_'+cont_id+' .msgKO').show();
            }
            $('.form_'+cont_id+' .btn-enviarForm').prop("disabled",false);
            $('.form_'+cont_id+' .btn-enviar').show();
            $('.form_'+cont_id+' .btn-enviando').hide();

            var window_height = $(window).height();
            var window_top_position = $(window).scrollTop();
            if ($('.form_'+cont_id+' .msgOK').offset().top > (window_top_position + window_height * 0.75) || $('.form_'+cont_id+' .msgOK').offset().top < (window_top_position + 150) ){
            if ($(window).width() < 740){
              $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgOK').offset().top-120 }, 400);
            } else{
              $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgOK').offset().top-200 }, 400);
            }
            }
            if ($('.form_'+cont_id+' .msgKO').offset().top > (window_top_position + window_height * 0.75) || $('.form_'+cont_id+' .msgKO').offset().top < (window_top_position + 150) ){
              if ($(window).width() < 740){
                $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgKO').offset().top-120 }, 400);
              } else{
                $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgKO').offset().top-200 }, 400);
              }
            }
          },
          cache: false,
          contentType: false,
          processData: false
      });
  },500)
}

function sendSalesforcetest(cont_id){
  $('.form_'+cont_id+' .btn-enviar').hide();
  $('.form_'+cont_id+' .btn-enviando').show();
  //console.log($('.form_'+cont_id+' .btn-enviando').length);
  $('.form_'+cont_id+' .btn-enviarForm').prop("disabled",true);
  var csrfToken = $('meta[name="csrf-token"]').attr("content");
    var json = $('.form_'+cont_id).serializeObject();
    var form = document.querySelector('.form_'+cont_id);
    var formData = new FormData(form);
    
  formData.append("_csrf", csrfToken);
  formData.append("lang_id", $('.form_'+cont_id).attr("data-langid"));
  formData.append("cont_id", cont_id);
  formData.append("json", JSON.stringify(json));
  formData.append("page", window.location.href);
  $('.form_'+cont_id+' .msgOK,.form_'+cont_id+' .msgKO').hide();
  var baseurl = $('.form_'+cont_id).attr("data-baseurl");
  setTimeout(function(){
    $.ajax({
          url: baseurl+"/ajax/sendformsalesforcetest",
          type: 'POST',
          data: formData,
          dataType: 'json',
          async: false,
          success: function (data) {
            if(data.code==1){
              $('.form_'+cont_id+' .msgOK').show();
              $('.form_'+cont_id).addClass('sended');
              $('.form_'+cont_id+' input[type="text"]').val("");
              $('.form_'+cont_id+' input[type="email"]').val("");
              $('.form_'+cont_id+' textarea').val("");
            }else{
              $('.form_'+cont_id+' .msgKO').show();
            }
            $('.form_'+cont_id+' .btn-enviarForm').prop("disabled",false);
            $('.form_'+cont_id+' .btn-enviar').show();
            $('.form_'+cont_id+' .btn-enviando').hide();

            var window_height = $(window).height();
            var window_top_position = $(window).scrollTop();
            if ($('.form_'+cont_id+' .msgOK').offset().top > (window_top_position + window_height * 0.75) || $('.form_'+cont_id+' .msgOK').offset().top < (window_top_position + 150) ){
            if ($(window).width() < 740){
              $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgOK').offset().top-120 }, 400);
            } else{
              $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgOK').offset().top-200 }, 400);
            }
            }
            if ($('.form_'+cont_id+' .msgKO').offset().top > (window_top_position + window_height * 0.75) || $('.form_'+cont_id+' .msgKO').offset().top < (window_top_position + 150) ){
              if ($(window).width() < 740){
                $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgKO').offset().top-120 }, 400);
              } else{
                $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgKO').offset().top-200 }, 400);
              }
            }
          },
          cache: false,
          contentType: false,
          processData: false
      });
  },500)
}